import React from 'react';
import Heading from '../../components/Heading';
import AnnouncementsTable from '../../components/AnnouncementsTable';
import Tabs from '../../components/Tabs';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import { useAnnouncementsPageOrchestrator } from './CustomHooks/useAnnouncementsPageOrchestrator';

const Announcements = () => {
  const {
    announcements,
    isLoadingAnnouncements,
    searchTerm,
    onSearch,
    onDeleteAnnouncement,
    refreshAnnouncements,
  } = useAnnouncementsPageOrchestrator();

  return (
    <WithNavigation
      title="Announcements"
      top={
        <Heading
          headline="Announcements"
          loading={isLoadingAnnouncements}
          items={[
            {
              key: 'Announcements',
              value: announcements.length,
            },
          ]}
        />
      }
      bottom={
        <Tabs
          items={[
            {
              label: 'Announcements',
              length: announcements.length,
              content: (
                <AnnouncementsTable
                  announcements={announcements}
                  isLoadingAnnouncements={isLoadingAnnouncements}
                  searchTerm={searchTerm}
                  onSearch={onSearch}
                  onDeleteAnnouncement={onDeleteAnnouncement}
                  onSaved={refreshAnnouncements}
                />
              ),
            },
          ]}
        />
      }
    />
  );
};

export default Announcements;
